/**
 * RTK Query API for Expense Invoices
 * Uses genericApiFactory for base CRUD operations
 */

import { createGenericApiSlice } from '../../../Api/Factory/genericApiFactory';
import { TagTypes } from '../../../Api/Types/tagTypes';
import { ExpenseInvoiceDto } from '../Types/expenseInvoice.types';

/**
 * Base CRUD API generated by genericApiFactory
 * Extended endpoints in extendedExpenseInvoicesApi.ts
 */
export const expenseInvoicesApi = createGenericApiSlice<ExpenseInvoiceDto>({
  reducerPath: 'expenseInvoicesApi',
  tag: TagTypes.ExpenseInvoice,
  endpoint: 'expense-invoices',
});

// Export base CRUD hooks (aliased for consistency)
export const {
  useGetAllQuery: useGetAllExpenseInvoicesQuery,
  useGetByIdQuery: useGetExpenseInvoiceByIdQuery,
  useCreateMutation: useCreateExpenseInvoiceMutation,
  useUpdateMutation: useUpdateExpenseInvoiceMutation,
  useDeleteMutation: useDeleteExpenseInvoiceMutation,
} = expenseInvoicesApi;
